import { render, staticRenderFns } from "./testPaper.vue?vue&type=template&id=39c31d28&scoped=true"
import script from "./testPaper.vue?vue&type=script&lang=js"
export * from "./testPaper.vue?vue&type=script&lang=js"
import style0 from "./testPaper.vue?vue&type=style&index=0&id=39c31d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c31d28",
  null
  
)

export default component.exports